import { ClassGroupType, Style, ThemeStyle } from "../../Style.types";
import { adjustColor } from "../../lib";

export interface IInputClassGroup {
  input: ThemeStyle;
  inputMedium: Style;
  inputSmall: Style;
  inputLarge: Style;
  inputError: ThemeStyle;
  inputSuccess: ThemeStyle;
  inputFocus: ThemeStyle;
  inputDisabled: ThemeStyle;
}
export const InputClassGroup: ClassGroupType<IInputClassGroup> = {
  input: (theme) => ({
    fontFamily: theme.fonts.primary.regular,
    textAlign: "left",
    fontSize: theme.fonts.baseSize * 0.875,
    minWidth: 200,
    borderRadius: 8,
    backgroundColor: adjustColor(theme.colors.secondary.light, 1.0, 0.15),
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: "transparent",
    color: theme.colors.neutralLighter.contrast,
  }),
  inputError: (theme) => ({
    borderColor: theme.colors.danger.main,
  }),
  inputSuccess: (theme) => ({
    borderColor: theme.colors.success.main,
  }),
  inputFocus: (theme) => ({
    borderColor: theme.colors.primary.main,
  }),
  inputDisabled: (theme) => ({
    backgroundColor: theme.colors.neutralLighter.main,
    color: theme.colors.neutralLighter.dark,
  }),
  inputSmall: {
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 4,
    paddingBottom: 4,
  },
  inputMedium: {
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: 8,
    paddingBottom: 8,
  },
  inputLarge: {
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 8,
    paddingBottom: 8,
  },
};
